import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDoubleTap } from "use-double-tap";

import styles from "./ReferenceWeb.module.scss";
import { getIconForBlockType, truncate } from "../../../Utils/Utils";
import { useTranslation } from "react-i18next";
import Reference from "../Reference/Reference";
import { toast } from "react-toastify";

const propTypesReferenceWeb = {
  povType: PropTypes.string.isRequired,
  povId: PropTypes.string.isRequired,
  deleteLoading: PropTypes.bool,
  editMode: PropTypes.bool,
  onGoTo: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  reference: PropTypes.shape({
    title: PropTypes.string,
    descriptionTo: PropTypes.string,
    descriptionFrom: PropTypes.string,
    webLink: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
      iconUrl: PropTypes.string,
    }).isRequired,
    source: PropTypes.shape({
      entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
      block: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        image: PropTypes.shape({
          url: PropTypes.string,
        }),
        entry: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          image: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
      }),
    }),
  }).isRequired,
};
const defaultPropsReferenceWeb = {
  deleteLoading: false,
  editMode: true,
};

const ReferenceWeb = ({
  reference,
  deleteLoading,
  editMode,
  onGoTo,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  let text;
  if (reference.title) {
    text = reference.title;
  } else if (reference.webLink.title) {
    text = reference.webLink.title;
  } else {
    text = reference.webLink.url;
  }
  const imageUrl = reference.webLink.iconUrl;

  const onItemClicked = (item) => {
    if (item.key === "goto") {
      onGoTo(reference.webLink.url);
    }
    if (item.key === "copy") {
      const el = document.createElement("textarea");
      el.value = reference.webLink.url;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      toast.success(t(`wisdomtree.entry_browser.reference_copied`), {
        autoClose: 2000,
      });
    }
    if (item.key === "edit") {
      onEdit();
    }
    if (item.key === "remove") {
      onRemove();
    }
  };

  const dropdownItems = [
    {
      key: "goto",
      text: t("wisdomtree.entry_browser.reference_goto_web"),
      icon: "fa-external-link-alt",
      tooltip: t("wisdomtree.entry_browser.tooltips.reference_goto_web"),
    },
    {
      key: "copy",
      text: t("wisdomtree.entry_browser.reference_copy"),
      icon: "fa-copy",
      tooltip: t("wisdomtree.entry_browser.tooltips.reference_copy"),
    },
  ];

  if (editMode) {
    dropdownItems.push({
      key: "edit",
      text: t("wisdomtree.entry_browser.reference_edit"),
      icon: "fa-pen",
      tooltip: t("wisdomtree.entry_browser.tooltips.reference_edit"),
    });
    dropdownItems.push({
      key: "remove",
      text: t("wisdomtree.entry_browser.reference_remove"),
      icon: "fa-unlink",
      tooltip: t("wisdomtree.entry_browser.tooltips.reference_remove"),
    });
  }

  const titleNode = <p className={styles.text}>{truncate(text, 34, true)}</p>;

  return (
    <Reference
      titleNode={titleNode}
      imageUrl={imageUrl ? imageUrl : null}
      imagePlaceholderIcon="fa-globe"
      description={
        reference.descriptionTo
          ? truncate(reference.descriptionTo, 16, true)
          : null
      }
      onDoubleTap={() => {
        onGoTo(reference.webLink.url);
      }}
      dropdownItems={dropdownItems}
      onDropdownItemClicked={onItemClicked}
      deleteLoading={deleteLoading}
      previewImage={false}
    />
  );
};

ReferenceWeb.propTypes = propTypesReferenceWeb;
ReferenceWeb.defaultProps = defaultPropsReferenceWeb;

export default ReferenceWeb;
